export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14901.052a8ff9.jpg";